/* eslint-disable @typescript-eslint/no-var-requires */
import React, { FunctionComponent, MutableRefObject, useRef } from 'react';

import './animation021.less';
import ImgPoint from '../../../../../assets/animation_point.gif';

interface IAnimation021Item {
  icon: string;
  text: string;
}

interface IAnimation021Props {
  items: IAnimation021Item[];
  onCompleted: () => void;
}

const Animation021: FunctionComponent<IAnimation021Props> = ({
  items,
  onCompleted,
}) => {
  const crrRef = useRef() as MutableRefObject<HTMLDivElement>;
  const [play, setPlay] = React.useState(1);
  const [isPlayed, setIsPlayed] = React.useState(false);
  const startPlay = (next = 1) => {
    if (isPlayed) {
      return;
    }
    next += 1;
    setPlay(next);
    setIsPlayed(true);
    if (next <= items.length) {
      setTimeout(() => startPlay(next), 2100);
    } else {
      console.log('Animation021 onCompleted');
      onCompleted && onCompleted();
    }
  };
  const getImg = (img: string) =>
    require(`../../../../../assets/${img}`).default;
  return (
    <div ref={crrRef} className="animation021 component">
      <div className="animation021-content">
        {items.map((itm: IAnimation021Item, idx: number) => (
          <div
            key={idx}
            className={`animation021-item animation ${
              play >= idx + 1 ? 'fade-in' : ''
            }`}
            onClick={() => startPlay()}
            style={{
              width: `${(1 / items.length) * 100 - 2}%`,
            }}
          >
            {idx % 2 === 0 ? (
              <>
                <div
                  className="animation021-text"
                  dangerouslySetInnerHTML={{ __html: itm.text }}
                />
                <div className="animation021-icon">
                  <img src={getImg(itm.icon)} alt="" />
                </div>
              </>
            ) : (
              <>
                <div className="animation021-icon">
                  <img src={getImg(itm.icon)} alt="" />
                </div>
                <div
                  className="animation021-text"
                  dangerouslySetInnerHTML={{ __html: itm.text }}
                />
              </>
            )}
            <img
              className={`click-point ${play > 1 ? 'hide' : ''}`}
              src={ImgPoint}
              alt=""
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Animation021;
